<script setup>
import { defineProps, defineEmits } from "vue";

const emit = defineEmits(["setActiveItem", "setActiveMenu"]);
const props = defineProps({
  activeItem: String,
  activeMenu: String,
});

const setActive = (status) => {
  emit("setActiveItem", status);
  emit("setActiveMenu", "courses");
};
</script>

<template>
  <li class="nav-item has-treeview menu-open">
    <a class="nav-link" :class="{ active: props.activeMenu === 'courses' }">
      <font-awesome-icon class="nav-icon" :icon="['fas', 'fa-handshake']" />
      <p>
        Courses
        <font-awesome-icon class="right" :icon="['fas', 'fa-angle-left']" />
      </p>
    </a>
    <ul class="nav nav-treeview">
      <li class="nav-item">
        <router-link
          to="/dashboard/courses"
          class="nav-link"
          :class="{ active: props.activeItem === 'all-courses' }"
          @click="setActive('all-courses')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>All courses</p>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/dashboard/courses/kpis"
          class="nav-link"
          :class="{ active: props.activeItem === 'courses-kpi' }"
          @click="setActive('courses-kpi')"
        >
          <font-awesome-icon class="nav-icon" :icon="['far', 'fa-circle']" />
          <p>Course KPIs</p>
        </router-link>
      </li>
    </ul>
  </li>
</template>
